import { useAtomValue } from "jotai";
import { DeliveryMethods } from "../utils/enum";
import {
  hasOrdersAtom,
  hasSessionAtom,
  isTableAndHasSessionAtom,
  isTableAndNoSessionAtom,
  isTableOrderEditingAtom,
  posOrderSessionDataAtom,
  sessionTotalAmountAtom,
  showPaymentsAtom,
} from "../atoms/usePosOrderTableSessionAtoms";
import usePosOrderDeliveryMethod from "../atoms/usePosOrderDeliveryMethodAtom";

export const useHasSession = () => useAtomValue(hasSessionAtom);
export const useShowPayments = () => useAtomValue(showPaymentsAtom);
export const useSessionId = () =>
  useAtomValue(posOrderSessionDataAtom)?.session_id;

export const useSessionCurrentTableIds = () =>
  useAtomValue(posOrderSessionDataAtom)?.current_table_ids ?? [];
export const useSessionTotalAmount = () => useAtomValue(sessionTotalAmountAtom);
export const useHasOrders = () => useAtomValue(hasOrdersAtom);
export const useIsTableAndNoSession = () =>
  useAtomValue(isTableAndNoSessionAtom);
export const useIsTableAndHasSession = () =>
  useAtomValue(isTableAndHasSessionAtom);
export const useIsTableOrderEditing = () =>
  useAtomValue(isTableOrderEditingAtom);

export const useIsTableMethod = () => {
  const [deliveryMethod] = usePosOrderDeliveryMethod();
  return deliveryMethod === DeliveryMethods.DINE_IN;
};
